export default {
  GROUPS: 'Groups',
  PERMISSIONS: 'Permissions',
  SAVE: 'Save',
  CANCEL: 'Cancel'
}
